export interface Testimonial {
  quote: string
  name: string
  role: string
  location: string
  highlight: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'I used to spend an hour most evenings deciding what to teach. Now I open the library, pick a class that fits the group, and spend that time reviewing instead of building.',
    name: 'Hannah M.',
    role: 'Vinyasa & Hatha Instructor',
    location: 'United Kingdom',
    highlight: 'Less planning time',
  },
  {
    quote:
      'My classes had started to repeat themselves. Six volumes means real variety week to week without inventing something new every time.',
    name: 'Daniel R.',
    role: 'Studio Teacher, 200-HR',
    location: 'USA',
    highlight: 'More variety',
  },
  {
    quote:
      'The cueing language surprised me. I read the cues before class and my teaching sounds clearer — fewer filler words, better timing.',
    name: 'Aoife K.',
    role: 'Slow Flow & Yin Teacher',
    location: 'Ireland',
    highlight: 'Clearer cueing',
  },
  {
    quote:
      'Some weeks inspiration just isn’t there. On those weeks I still walk in with a complete, well-structured plan.',
    name: 'Priya S.',
    role: 'Community Class Instructor',
    location: 'Canada',
    highlight: 'A reliable library',
  },
  {
    quote:
      'I teach a gentle morning group and a stronger evening group. The modifications make it simple to run one structure for both.',
    name: 'Ellie T.',
    role: 'Mobility & Restorative Teacher',
    location: 'Australia',
    highlight: 'Easy to adapt',
  },
]
